import { namespace } from 'vuex-class';
import { BindingHelpers } from 'vuex-class/lib/bindings';
import { ITrackingState } from './tracking.types';

export const trackingModuleName = 'tracking';
export const trackingModulePath = 'documentView/tracking';

export const Tracking: BindingHelpers = namespace(trackingModulePath);

export function getDefaultState(): ITrackingState {
  return {
    loaded: false,
    loading: false,
    tracking: {
      id: null,
      clickTrackings: [],
      pageTrackings: [],
      visitTrackings: [],
      videoTrackings: [],
    },
    selectedRecipientId: null,
  };
}
